
export const startSecureStream = async (obraId, cameraId) => {

  const response = await fetch(`/api/stream/${obraId}/${cameraId}`, {
    method: 'POST',
  });

  if (!response.ok) {

    const errorData = await response.json().catch(() => ({ message: 'Falha ao iniciar o stream seguro.' }));
    throw new Error(errorData.message);
  }
  return response.json();
};



export const stopStream = async (streamId) => {
  try {
    await fetch('/stop-stream', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ streamId }),
      keepalive: true,
    });
  } catch (error) {

  }
};


export const sendHeartbeat = async (streamId) => {
  try {
    await fetch('/heartbeat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ streamId }),
      keepalive: true,
    });
  } catch (error) {
    console.error(`Erro ao enviar heartbeat para ${streamId}:`, error);
  }
};
